/**
 * Moduldefinitionen
 */
export enum ModuleList {
    NONE = -1,
    TIME_MANAGEMENT = 1,
    TODO = 2
}
